import "../../components/material-toggle.js";
import "../../components/paper-options.js";
import "../../components/acryl-options.js";
import "../../components/aluminium-options.js";
import "../../components/gift-options.js";
import "../../components/wallable-watermark.js";
import "html2canvas";
import "@woocommerce/woocommerce-rest-api";

import html2canvas from "html2canvas";
import * as $ from "jquery";
import * as bootstrap from "bootstrap";
import { Options } from "./options-date-poster.js";
import { getShippingDate } from "./helpers/shipping-date.js";
import { resizePosterPreview } from "./helpers/resize-poster-preview.js";
import { getShoppingBagSummary } from "./helpers/shopping-bag-summary.js";
import { DebugReporter } from "./helpers/debug-reporter.js";
import { uploadProductScreenshot } from "./helpers/image-uploader.js";
import { initializeI18n } from "./i18n/initialize.js";
import { resolveCatalogProduct } from "./catalog/product-catalog.js";
import { getBuilderUrl } from "./config/builder-routes.js";

let woocommerceUrl = process.env.WOOCOMMERCE_URL || window.location.origin;
const apiBase = "";
let marketContext;
let t = (key) => key;
let formatCurrency = (value) => `€${Number(value).toFixed(2).replace(".", ",")}`;
let formatDate = (value) => String(value);

const i18nReady = initializeI18n().then((i18n) => {
  ({ marketContext, t, formatCurrency, formatDate } = i18n);
  woocommerceUrl = marketContext.services.woocommerceBaseUrl;
});

const options = new Options();

const PosterColors = {
  1: {
    bg: "transparent",
    text: "#000000",
  },
  2: {
    bg: "#f0ece38b",
    text: "#97896aff",
  },
  3: {
    bg: "#c6e0e695",
    text: "#4c747dff",
  },
  4: {
    bg: "#f8d5d58d",
    text: "#b47474ff",
  },
  5: {
    bg: "#cef1ce8d",
    text: "#72ba72ff",
  },
  6: {
    bg: "#fff7d783",
    text: "#b8a557ff",
  },
};

let PosterPreviewImage;
let ShowMobileSettingPanel = false;
let PrintTypeSelected = true;
const BuilderName = $("body").attr("id");

let SettingsPanel = options.get("settingsPanel", "map");
let PosterSize = options.get("posterSize", "small");
let PosterFrame = options.get("posterFrame", "black");
let PosterColorNumber = options.get("PosterColorNumber", "1");
let AcrylBlock = options.get("acrylBlock", "black");
let AluminiumColor = options.get("aluminiumColor", "silver");
let PrintType = options.get("printType", "paper");
let GiftCardText = "";

const DayInput = $("#day-input");
const DayLabel = $(".labels .day");
const MonthInput = $("#month-input");
const MonthLabel = $(".labels .month");
const YearInput = $("#year-input");
const YearLabel = $(".labels .year");
const EventInput = $("#event-input");
const EventLabel = $(".labels .event-content");
const NamesInput = $("#names-input");
const NamesLabel = $(".labels .names");
const PosterWrapper = $(".map-wrapper");
const PosterSizeSelect = $(".js-poster-size");
const PosterFrameSelect = $(".js-poster-frame");
const PosterGiftwrapSelect = $(".js-giftwrap");
const GiftCardSelect = $(".js-giftcard");
const AcrylBlockSelect = $(".js-acryl-block");
const PrintTypeSelect = $(".js-print-type");

const debugReporter = DebugReporter({
  ajaxUrl: apiBase + "/wp-json/wallable/v1/client-diagnostics",
  containerSelector: ".js-notifications",
  shouldShow: ({ meta }) =>
    meta?.action === "add-to-cart" || meta?.action === "add-poster-order",
  extraContext: () => ({
    builder: $("body").attr("id"),
  }),
}).init();

// Load saved poster after locale and market configuration are available.
i18nReady.then(() => {
  getSavedPoster();
  toggleProductionEnv();
  calculatePosterPrice();
  resizePosterWrapper();
  toggleClearIcons();
  setPreviewMode();
});

$(document).ready(async function () {
  await i18nReady;
  window.status = "mapbox-ready";
  setTimeout(() => {
    $(".anim-wrapper").removeClass("hidden");
    $(".loading-wrapper").remove();
  }, "500");
});

// For dismissing panel if previewing from shopping cart
function setPreviewMode() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("preview")) {
    dismissSettingsPanel();
  }
}

// Input listeners
$("input.form-control").on("input", function () {
  const posterLabel = this.dataset.posterLabel;

  if (!posterLabel) return;

  let inputValue = $(this).val();

  if ($(this).attr("type") === "number" && inputValue >= 0) {
    inputValue = formatDateInteger(inputValue);
    $(this).val(inputValue);
  }

  $(".labels ." + posterLabel).html(inputValue);

  $('.js-clear-input[data-field-id="' + posterLabel + '"]').toggle(
    inputValue !== "",
  );
});

function formatDateInteger(inputValue) {
  const validIntegerPattern = /^(0|[1-9]\d*)$/;
  let formattedNumber;

  if (validIntegerPattern.test(inputValue)) {
    formattedNumber = inputValue < 10 ? `0${inputValue}` : `${inputValue}`;
  } else {
    // Remove leading zeros and update the input field
    const cleanedValue = inputValue.replace(/^0+/, "0");
    formattedNumber = cleanedValue;
  }

  return formattedNumber;
}

$(".js-history-back").on("click", function () {
  history.back();
});

// Clear input fields
$(".js-clear-input").on("click", function () {
  const field = $(this).data("field-id");

  $('input.form-control[data-poster-label="' + field + '"]')
    .val("")
    .trigger("input")
    .trigger("focus");
});

// Check if field has value and show clear icon
function toggleClearIcons() {
  const inputFields = $("input.form-control");

  inputFields.each(function () {
    const inputValue = $(this).val();

    if (inputValue.trim() === "") {
      let emptyField = $(this).data("poster-label");
      $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
    }
  });
}

// Change poster color
$(".js-style-option").on("click", function () {
  PosterColorNumber = $(this).attr("data-style");
  setPosterColor(PosterColorNumber);
  setPosterColorSelection(PosterColorNumber);
});

function setPosterColor(colorNumber) {
  $(".poster-canvas").css("background-color", PosterColors[colorNumber].bg);
  $(".poster-canvas .labels").css("color", PosterColors[colorNumber].text);
  $(".poster-canvas .divider").css(
    "background-color",
    PosterColors[colorNumber].text,
  );
}

function setPosterColorSelection(colorNumber) {
  var selectedColor = $('.js-style-option[data-style="' + colorNumber + '"]');
  $(".js-style-option").removeClass("active");
  selectedColor.addClass("active");
  dismissSettingsPanel();
}

// Changing poster
function setPosterSize(posterSize) {
  PosterWrapper.removeClass().addClass(
    "map-wrapper size-" + posterSize + " " + PrintType,
  );
}

// Change poster size
$(".js-size-option").on("click", function () {
  PosterSize = $(this).attr("data-size");
  setPosterSize(PosterSize);
  setSizeSelection(PosterSize);
  calculatePosterPrice();
});

function setSizeSelection(posterSize) {
  let selectedSize = $(
    '.js-toggle-for-material[data-material="' +
      PrintType +
      '"] .js-size-option[data-size="' +
      posterSize +
      '"]',
  );

  $(".js-size-option").removeClass("active");
  selectedSize.addClass("active");

  if (PrintType !== "paper") return;

  let framePrice = 0;
  let frameNormalPrice = 0;
  switch (posterSize) {
    case "small":
      framePrice = 15;
      frameNormalPrice = 21.95;
      break;
    case "medium":
      framePrice = 20;
      frameNormalPrice = 24.95;
      break;
    case "large":
      framePrice = 35;
      frameNormalPrice = 39.95;
      break;
    default:
      framePrice = 0;
      frameNormalPrice = 0;
  }

  // If extra-large, force no frame
  if (posterSize === "extra-large") {
    PosterFrame = "no-frame";
    setFrameSelection(PosterFrame);
    setPosterFrame(PosterFrame);
    $(".js-frame-option").addClass("disabled");
    $('.js-frame-option[data-frame="no-frame"]').removeClass("disabled");
    $("small[frame-normal-price]").text("-");
    $("small[frame-price]").hide();
  } else {
    $(".js-frame-option").removeClass("disabled");
    $("small[frame-price]").show();
    $("small[frame-price]").text(formatCurrency(framePrice));
    $("small[frame-normal-price]").text(formatCurrency(frameNormalPrice));

    $(".js-frame-option")
      .not('[data-frame="no-frame"]')
      .attr("data-price", framePrice.toFixed(2));
  }
}

// Change print type
$(document).on("click", ".js-print-option", function () {
  let SelectedPrintType = $(this).attr("data-print");
  if (PrintType !== SelectedPrintType) {
    PrintType = SelectedPrintType;
    setPrintType(PrintType);
  }
  if ($(this).hasClass("d-block")) {
    PrintTypeSelected = true;
  }
  togglePrintTypes();
});

$(document).on("click", ".js-show-print-types", function () {
  togglePrintTypes();
});

function setPrintType(PrintType) {
  var selectedPrint = $('.js-print-option[data-print="' + PrintType + '"]');
  $(".js-print-option").removeClass("active");
  selectedPrint.addClass("active");

  // If acryl
  if (PrintType == "acryl") {
    if (PosterSize === "large" || PosterSize === "extra-large") {
      PosterSize = "small";
    }
    PosterFrame = "no-frame";

    // If aluminium
  } else if (PrintType == "aluminium") {
    if (PosterSize === "large" || PosterSize === "extra-large") {
      PosterSize = "medium";
    }
    PosterFrame = "no-frame";
    setAluminiumColor(AluminiumColor);

    // If paper
  } else {
    if (PosterSize === "xs") {
      PosterSize = "small";
    } else if (PosterSize === "extra-large") {
      PosterSize = "large";
    }
    AcrylBlock = "no-block";
  }
  setAcrylBlock(AcrylBlock);
  setBlockSelection(AcrylBlock);
  setFrameSelection(PosterFrame);
  setPosterFrame(PosterFrame);
  setPosterSize(PosterSize);
  setSizeSelection(PosterSize);
  calculatePosterPrice();
}

function togglePrintTypes() {
  if (PrintTypeSelected) {
    $(".js-print-option").hide();
    $(".js-toggle-for-material").hide();
    $(".js-show-print-types").show();
    $(".js-toggle-for-material[data-material='" + PrintType + "']").show();
    $(".js-print-option[data-print='" + PrintType + "']").show();
    PrintTypeSelected = false;
  } else {
    $(".js-print-option").show();
    $(".js-show-print-types").hide();
    $(".js-toggle-for-material").hide();
    PrintTypeSelected = true;
  }
}

// Change aluminium color
$(".js-color-option").on("click", function () {
  AluminiumColor = $(this).attr("data-color");
  setAluminiumColor(AluminiumColor);
  setAluminiumColorSelection(AluminiumColor);
});

function setAluminiumColor(color) {
  PosterWrapper.attr("data-aluminium-color", color);
}

function setAluminiumColorSelection(color) {
  var selectedColor = $('.js-color-option[data-color="' + color + '"]');
  $(".js-color-option").removeClass("active");
  selectedColor.addClass("active");
}

// Change acryl block
$(".js-block-option").on("click", function () {
  AcrylBlock = $(this).attr("data-block");
  setBlockSelection(AcrylBlock);
  setAcrylBlock(AcrylBlock);
  calculatePosterPrice();
});

function setBlockSelection(AcrylBlock) {
  var selectedBlock = $('.js-block-option[data-block="' + AcrylBlock + '"]');
  $(".js-block-option").removeClass("active");
  selectedBlock.addClass("active");
}

function setAcrylBlock(AcrylBlock) {
  $(".aluminium-stand").hide();
  $(".acryl-block").show();
  PosterWrapper.attr("data-perspective", false);
  if (AcrylBlock == "black") {
    $(".acryl-block").removeClass("d-none oak").addClass("black");
    PosterWrapper.attr("data-perspective", true);
  } else if (AcrylBlock == "oak") {
    $(".acryl-block").removeClass("d-none black").addClass("oak");
    PosterWrapper.attr("data-perspective", true);
  } else {
    $(".acryl-block").removeClass("oak black").addClass("d-none");
  }
}

// Change poster frame
$(".js-frame-option").on("click", function () {
  PosterFrame = $(this).attr("data-frame");
  setFrameSelection(PosterFrame);
  setPosterFrame(PosterFrame);
  activateGiftwrap(PosterFrame);
  calculatePosterPrice();
});

function setPosterFrame(PosterFrame) {
  const frameElement = $(".poster-frame");
  const frameClasses = ["black-frame", "oak-frame", "white-frame"];

  frameElement.removeClass(frameClasses.join(" ") + " d-none");

  if (frameClasses.includes(PosterFrame + "-frame")) {
    frameElement.addClass(PosterFrame + "-frame");
  } else {
    frameElement.addClass("d-none");
  }
  activateGiftwrap();
}

function setFrameSelection(frame) {
  var selectedFrame = $('.js-frame-option[data-frame="' + frame + '"]');
  $(".js-frame-option").removeClass("active");
  selectedFrame.addClass("active");
}

// Toggle giftwrap
$(".js-giftwrap").on("change", function () {
  calculatePosterPrice();
});

function activateGiftwrap() {
  if (PrintType === "paper" && PosterFrame === "no-frame") {
    PosterGiftwrapSelect.val("false");
    $(".js-giftwrap option[value=true]")
      .attr("disabled", "disabled")
      .siblings()
      .removeAttr("disabled");
  } else {
    $(".js-giftwrap option[value=true]").removeAttr("disabled");
  }
}

// Change giftcard text
$(".js-giftcard").on("change", function () {
  if ($(this).val() === "true") {
    $(".js-giftcard-text").show();
    GiftCardText = $(".js-giftcard-text").val();
  } else {
    $(".js-giftcard-text").hide();
    GiftCardText = "";
  }
  calculatePosterPrice();
});

$(".js-giftcard-text").on("change", function () {
  GiftCardText = $(this).val();
});

// Calculate poster price
function calculatePosterPrice() {
  const getPrice = (selector) =>
    parseFloat($(selector).find(".active, :selected").attr("data-price")) || 0;

  const subtotalPrice =
    getPrice(PosterSizeSelect) +
    getPrice(AcrylBlockSelect) +
    getPrice(PosterFrameSelect) +
    getPrice(PosterGiftwrapSelect) +
    getPrice(GiftCardSelect);

  $(".subtotal").html(formatCurrency(subtotalPrice));
}

// Create poster preview image
function createPosterPreview() {
  $(".poster-frame, .block-wrapper").addClass("hidden");
  $(".map-wrapper").addClass("shadow-none");
  const element = document.querySelector(".poster-wrapper");

  html2canvas(element, {
    scale: window.devicePixelRatio || 2,
    useCORS: true,
    backgroundColor: "#ffffff",
  }).then((canvas) => {
    PosterPreviewImage = canvas.toDataURL("image/jpeg", 0.8);
    $(".js-poster-preview").attr("src", PosterPreviewImage);
  });
  $(".map-wrapper").removeClass("shadow-none");
  $(".poster-frame, .block-wrapper").removeClass("hidden");
}

// For hiding some unnecessary fields on staging
function toggleProductionEnv() {
  if (process.env.OAK_FRAMES === "false") {
    $('[data-frame="oak"]').remove();
  }
  if (process.env.ACRYL_PRODUCTS === "false") {
    if (PrintType === "acryl") {
      PrintType = "paper";
      PosterWrapper.removeClass("acryl");
    }
    $(".js-show-for-acryl").remove();
    $(".js-hide-for-acryl").show();
    $(".js-material-toggle [data-print='acryl']").remove();
  }
  if (process.env.ALUMINIUM_PRODUCTS === "false") {
    if (PrintType === "aluminium") {
      PrintType = "paper";
      PosterWrapper.removeClass("aluminium");
    }
    $(".js-show-for-aluminium").remove();
    $(".js-hide-for-aluminium").show();
    $(".js-material-toggle [data-print='aluminium']").remove();
  }
}

// For removing default values from poster
function removeDefaultValue(value) {
  const defaultValues = [
    "Naam &amp; Naam",
    "Gebeurtenis",
    t("datePoster.defaults.names"),
    t("datePoster.defaults.names").replaceAll("&", "&amp;"),
    t("datePoster.defaults.event"),
  ];

  var isMatch = false;

  for (var i = 0; i < defaultValues.length; i++) {
    if (defaultValues[i] === value) {
      isMatch = true;
      break;
    }
  }

  if (isMatch) {
    return "";
  } else {
    return value;
  }
}

// For saving design to local storage
function saveDesign() {
  localStorage.setItem("posterSize", PosterSize);
  localStorage.setItem("posterFrame", PosterFrame);
  localStorage.setItem("DayLabel", DayLabel.html());
  localStorage.setItem("MonthLabel", MonthLabel.html());
  localStorage.setItem("YearLabel", YearLabel.html());
  localStorage.setItem("EventLabel", EventLabel.html());
  localStorage.setItem("NamesLabel", NamesLabel.html());
  localStorage.setItem("PosterColorNumber", PosterColorNumber);
  localStorage.setItem("printType", PrintType);
  localStorage.setItem("acrylBlock", AcrylBlock);
  localStorage.setItem("aluminiumColor", AluminiumColor);
}

// For getting design from local storage or parameters
function getSavedPoster() {
  // Prepare text labels
  if (BuilderName !== "PrintApp") {
    if (options.get("DayLabel") !== null) {
      var dayLabel = options.get("DayLabel");
    } else {
      var dayLabel = "01";
    }

    if (options.get("MonthLabel") !== null) {
      var monthLabel = options.get("MonthLabel");
    } else {
      var monthLabel = "07";
    }

    if (options.get("YearLabel") !== null) {
      var yearLabel = options.get("YearLabel");
    } else {
      var yearLabel = "21";
    }

    if (options.get("EventLabel") !== null) {
      var eventLabel = options.get("EventLabel");
    } else {
      var eventLabel = t("datePoster.defaults.event");
    }

    if (options.get("NamesLabel") !== null) {
      var namesLabel = options.get("NamesLabel");
    } else {
      var namesLabel = t("datePoster.defaults.names");
    }
  } else {
    var dayLabel = options.get("DayLabel");
    var monthLabel = options.get("MonthLabel");
    var yearLabel = options.get("YearLabel");
    var eventLabel = options.get("EventLabel");
    var namesLabel = options.get("NamesLabel");
  }

  // Set text labels
  DayLabel.html(dayLabel);
  DayInput.val(dayLabel);
  MonthLabel.html(monthLabel);
  MonthInput.val(monthLabel);
  YearLabel.html(yearLabel);
  YearInput.val(yearLabel);
  EventLabel.html(eventLabel);
  EventInput.val(eventLabel);
  NamesLabel.html(namesLabel);
  NamesInput.val(namesLabel);

  if (PrintType !== "acryl" && PrintType !== "aluminium") {
    if (PosterSize === "xs") {
      PosterSize = "small";
    }
    if (PrintType === "framed-poster" || PrintType === "tegel") {
      PrintType = "paper";
    }
  }

  PosterSizeSelect.val(PosterSize);
  setPosterSize(PosterSize);
  setSizeSelection(PosterSize);

  PrintTypeSelect.val(PrintType);
  setPrintType(PrintType);
  $(".js-toggle-for-material").hide();
  togglePrintTypes();

  PosterFrame = options.get("posterFrame");
  PosterFrame = PosterFrame === "framed" ? "black" : PosterFrame;
  PosterFrameSelect.val(PosterFrame);
  setPosterFrame(PosterFrame);
  setFrameSelection(PosterFrame);
  activateGiftwrap(PosterFrame);

  setPosterColor(PosterColorNumber);
  setPosterColorSelection(PosterColorNumber);
}

// Resize canvas
$(window).on("resize", function () {
  resizePosterWrapper();
});

function resizePosterWrapper() {
  resizePosterPreview();
}

window.visualViewport?.addEventListener("resize", resizePosterWrapper);

// Toggle settings panels
$(".js-settings-toggle").on("click", function () {
  var target = $(this).attr("data-target");
  $(".nav-link").removeClass("active");
  $(".nav-link[data-target=" + target + "]").addClass("active");

  if (target == "text" && SettingsPanel !== "text") {
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.text").removeClass("d-none");
    SettingsPanel = "text";
  } else if (target == "size" && SettingsPanel !== "size") {
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.size").removeClass("d-none");
    SettingsPanel = "size";
  } else if (target == "shop" && SettingsPanel !== "shop") {
    setPosterSummary();
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.shop").removeClass("d-none");
    $(".nav-pills .nav-link").removeClass("active");
    $("#pills-shop-tab").addClass("active");
    SettingsPanel = "shop";
  }

  if (ShowMobileSettingPanel == false) {
    $(".side-nav").addClass("shown");
    ShowMobileSettingPanel = true;
  }
  $(".options-container").scrollTop(0);
  saveDesign();
});

$(".js-close-settings").on("click", function () {
  dismissSettingsPanel();
});

function dismissSettingsPanel() {
  $(".side-nav").removeClass("shown");
  ShowMobileSettingPanel = false;
}

function isPrintApp() {
  return $("html").hasClass("PrintApp");
}

// Prepping shopping cart
function setPosterSummary() {
  getShoppingBagSummary(PosterSize, PrintType, PosterFrame, AcrylBlock, t);
  $(".js-shipping-date").html(getShippingDate({ t, formatDate }));
  createPosterPreview();
}

function getProductVariation() {
  const variationKey =
    PrintType === "paper" ? `${PosterSize}-${PosterFrame}` : PosterSize;
  const product = resolveCatalogProduct(
    marketContext.catalog,
    "date",
    PrintType,
    variationKey,
  );
  return {
    id: product?.id ?? null,
    variation_id: product?.variationId ?? null,
  };
}

// Adding poster to cart
$(".js-save-poster").on("click", async function () {
  saveDesign();
  let ProductID = getProductVariation();

  // window.open(url, '_blank').focus();

  $(this)
    .html(
      `${t("actions.savingDesign")} <span class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>`,
    )
    .prop("disabled", true);

  let thumbnailUrl;
  try {
    thumbnailUrl = await uploadProductScreenshot(
      PosterPreviewImage,
      BuilderName,
    );
  } catch (error) {
    console.error("Product screenshot kon niet worden opgeslagen", error);
    $(this).html(t("actions.addToCart")).prop("disabled", false);
    $(".js-notifications").append(
      `<div class="js-error alert alert-danger text-center p-2">${t("sportsmap.errors.saveFailed")}</div>`,
    );
    return;
  }

  let payload = {
    "add-builder-item-to-cart": true,
    edit_url: getBuilderUrl(marketContext, "date-poster", "/?preview"),
    thumbnail: thumbnailUrl,
    product_id: ProductID.id,
    variation_id: ProductID.variation_id,
    poster: {
      size: PosterSize,
      giftwrap: PosterGiftwrapSelect.val(),
      giftcardText: GiftCardText,
      dayLabel: localStorage.getItem("DayLabel"),
      monthLabel: localStorage.getItem("MonthLabel"),
      yearLabel: localStorage.getItem("YearLabel"),
      eventLabel: removeDefaultValue(localStorage.getItem("EventLabel")),
      namesLabel: removeDefaultValue(localStorage.getItem("NamesLabel")),
      posterColorNumber: localStorage.getItem("PosterColorNumber"),
      main: removeDefaultValue(localStorage.getItem("EventLabel")),
      ...(["aluminium"].includes(PrintType) && {
        aluminiumColor: localStorage.getItem("aluminiumColor"),
      }),
      ...(["aluminium", "acryl"].includes(PrintType) && {
        acrylBlock: localStorage.getItem("acrylBlock"),
      }),
      ...(["paper"].includes(PrintType) && {
        frame: PosterFrame,
      }),
    },
    pdf: {
      type: "date-poster",
      print:
        PrintType === "paper" && PosterFrame !== "no-frame"
          ? "framed-poster"
          : PrintType,
    },
  };

  // console.log("Payload: ", payload);

  let action =
    process.env.USE_CART === "true" ? "add-to-cart" : "add-poster-order";
  const endpoint = apiBase + "/wp-json/wallable/v1/" + action;
  let didRetryAsForm = false;

  const runAjax = (useFormEncoding = false) => {
    return $.ajax({
      url: endpoint,
      type: "POST",
      timeout: 20000,

      ...(useFormEncoding
        ? {
            data: { payload: JSON.stringify(payload) },
          }
        : {
            contentType: "application/json",
            data: JSON.stringify(payload),
          }),

      error: (jqXHR, textStatus, errorThrown) => {
        if (!useFormEncoding && !didRetryAsForm && jqXHR?.status === 0) {
          didRetryAsForm = true;
          return runAjax(true);
        }

        console.error(jqXHR, textStatus, errorThrown);

        setTimeout(() => {
          if (!$(".js-notifications").find(".js-error").length) {
            $(".js-notifications").append(
              `<div class="js-error alert alert-danger text-center p-2">${t("errors.generic")}</div>`,
            );
          }

          debugReporter.show({
            meta: { action, didRetryAsForm },
            request: {
              url: endpoint,
              method: "POST",
              mode: useFormEncoding ? "form" : "json",
              origin: window.location.origin,
              woocommerceUrl,
              online: navigator.onLine,
              visibilityState: document.visibilityState,
            },
            response: {
              status: jqXHR?.status,
              statusText: jqXHR?.statusText || textStatus,
              thrownError: errorThrown ? String(errorThrown) : null,
              responseText: (jqXHR?.responseText || "").slice(0, 4000),
            },
          });

          $(this).html(t("actions.addToCart")).prop("disabled", false);
        }, 500);
      },

      success: () => {
        if (action === "add-to-cart") {
          $(this).html(t("actions.addToCart")).prop("disabled", false);

          window.location = woocommerceUrl + "/cart/";
        } else {
          if (!$(".js-notifications").find(".js-error").length) {
            $(".js-notifications").append(
              `<div class="js-success alert alert-success text-center p-2">&#x2713; ${t("actions.posterAdded")}</div>`,
            );
          }
          $(this).html(t("actions.addToCart")).prop("disabled", false);
        }
      },
    });
  };

  runAjax(false);
});

// Tooltips
if (!isPrintApp()) {
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]'),
  );
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
}
